import { Box, Button, IconButton } from "@mui/material";
import { Sidebar } from "./Sidebar";
import { sendToWindow } from "./ServerUtils";
import { useEffect, useState } from "react";
import Calendar from "./TempCalendar";
import SyncIcon from '@mui/icons-material/Sync';

export function ContentCalendar({schedulable, setScheduledTime}) {
    const [scheduledPosts, setScheduledPosts] = useState([]);
  
    useEffect(() => {
      sync();
    }, []);

    function sync() {
      sendToWindow("GET_CACHABLE_RESPONSE", {
        url: "https://www.linkedin.com/voyager/api/graphql?includeWebMetadata=true&variables=(shareLifeCycleState:SCHEDULED,start:0,count:10)&queryId=voyagerContentcreationDashSharePreviews.f33546b41cd7df71aadd2ad9f1bf8753",
        method: "GET",
        body: JSON.stringify({}),
        forceFetch: true
      }).then(res => {
        console.log("Response: ", res);
        const posts = [];
        // decoded.data.contentcreationDashSharePreviewsByShareLifeCycleState.elements[0].miniUpdate.commentary
        for (let r of res.data.contentcreationDashSharePreviewsByShareLifeCycleState.elements) {
          if (r._type == 'com.linkedin.voyager.dash.contentcreation.SharePreview') {
            posts.push({
              scheduledAt: r.scheduledAt,
              text: r.miniUpdate?.commentary?.commentaryText?.text,
              urn: r.miniUpdate?.metadata?.backendUrn
            });
          }
        }
        setScheduledPosts(posts);
      });
    }

    function deletePost(post) {
      console.log("deleting post", post);
      const payload = {"variables":{"resourceKey":post.urn,"shareLifecycleState":"SCHEDULED"},"queryId":"voyagerContentcreationDashShares.b7155044c276d51764fc9981037204b3","includeWebMetadata":true};

      sendToWindow("DEBUG_EXECUTE_REQUEST", {
        url: "https://www.linkedin.com/voyager/api/graphql?action=execute&queryId=voyagerContentcreationDashShares.b7155044c276d51764fc9981037204b3",
        method: "POST",
        body: JSON.stringify(payload)
      }).then(res => {
        // refetch scheduled posts
        console.log("Response: ", res);
        sync();
      });
    }

    return (
        <div style={{
          padding: schedulable ? 0 : 20
        }}>
          <Calendar posts={scheduledPosts} sync={sync} schedulable={schedulable} setScheduledTime={setScheduledTime} deletePost={deletePost}/>
        </div>
    )
}